import React, { Fragment } from 'react';
import styles from './region-entity-table.module.scss';
import { EntityTableHeader } from './entity-table-header';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
} from '../../actions/ui';
import { ArrowRight } from '../../components/icons';

const cols = [
  { key: 'dam', align: 'left', format: (val) => val },
  { key: 'capacityMl', align: 'right', format: (val) => val.toLocaleString() },
  {
    key: 'storageLevel',
    align: 'right',
    format: (val) => (val * 100).toFixed(1) + '%',
  },
];

const EntityTableComponent = ({ entity, isMobile }) => {
  const [expanded, setExpanded] = React.useState(false);

  const { facilities } = entity;

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          width: '100%',
          overflow: 'auto',
          paddingLeft: isMobile ? 20 : 0,
        }}
      >
        <table className={styles.entityRegionTable} style={{ maxWidth: 700 }}>
          <tbody>
            <EntityTableHeader entity={entity} comparing={false} />
            {expanded && facilities && (
              <Fragment>
                {facilities
                  .sort((a, b) => a.storageLevel - b.storageLevel)
                  .map((facility) => {
                    return (
                      <tr key={facility.dam}>
                        {cols.map((col) => {
                          return (
                            <td key={col.key} style={{ textAlign: col.align }}>
                              {col.format(facility[col.key])}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
              </Fragment>
            )}
          </tbody>
        </table>
      </div>
      {entity.facilities.length > 0 && (
        <button
          className={styles.expandButton}
          onClick={() => setExpanded((e) => !e)}
        >
          {expanded ? 'Hide breakdown -' : 'View breakdown +'}
        </button>
      )}
      {isMobile && facilities.length > 0 && (
        <div className={styles.scrollTableMsg}>
          <span className={styles.cellInfoText}>
            Scroll the table to see more
          </span>
          <ArrowRight
            fill="blue"
            width="10px"
            height="10px"
            style={{ marginLeft: 10, marginTop: 10 }}
          />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
});

EntityTableComponent.propTypes = {
  entity: PropTypes.object,
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setComparedRegion: PropTypes.func,
};

const EntityTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(EntityTableComponent);
export { EntityTable };



// WEBPACK FOOTER //
// ./src/components/region-entity-table/entity-table.js